// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3LH3V","button":"styles_button__3kW9N","amount":"styles_amount__1f53w"};